import fontLoader from 'webfontloader';

fontLoader.load({
    google: {
        families: ['Inter:400,500,700']
    }
});
